<template>
  <div>
       <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100%"
      height="160px"
      viewBox="382.75 10 255.75 160.25"
      enable-background="new 382.75 10 255.75 160.25"
      xml:space="preserve"
    >
      <rect
        x="388"
        y="14.811"
        opacity="0.4"
        fill="#AAAAAA"
        enable-background="new    "
        width="242.334"
        height="150.189"
      />
      <rect
        x="393.732"
        y="14.878"
        fill="#EFEFF2"
        width="240.302"
        height="146.872"
      />
      <rect
        x="392.096"
        y="14.689"
        fill="#E5E5E5"
        width="14.313"
        height="147.061"
      />
      <rect
        x="391.096"
        y="14.689"
        fill="#FFFFFF"
        width="14.313"
        height="147.061"
      />
      <path
        fill="#E8E8E8"
        d="M404.167,48.068c0,0.745-0.584,1.349-1.304,1.349h-9.143c-0.72,0-1.304-0.604-1.304-1.349v-8.719
	c0-0.745,0.584-1.349,1.304-1.349h9.143c0.72,0,1.304,0.604,1.304,1.349V48.068z"
      />
      <ellipse
        fill="none"
        :stroke="color"
        stroke-miterlimit="10"
        cx="398.25"
        cy="43.605"
        rx="4.02"
        ry="3.936"
      />
      <ellipse
        fill="none"
        stroke="#070707"
        stroke-miterlimit="10"
        cx="398.252"
        cy="55.531"
        rx="4.02"
        ry="3.936"
      />
      <ellipse
        fill="none"
        stroke="#070707"
        stroke-miterlimit="10"
        cx="398.252"
        cy="67.342"
        rx="4.02"
        ry="3.936"
      />
      <ellipse
        fill="none"
        stroke="#070707"
        stroke-miterlimit="10"
        cx="398.252"
        cy="78.373"
        rx="4.02"
        ry="3.936"
      />
      <path
        fill="#FFFFFF"
        d="M514.597,90.362c0,2.235-2.31,4.045-5.16,4.045h-91.5c-2.85,0-5.161-1.811-5.161-4.045V47.756
	c0-2.233,2.311-4.045,5.161-4.045h91.5c2.85,0,5.16,1.811,5.16,4.045V90.362z"
      />
      <g id="Layer_2">
        <rect x="417.989" y="54.055" fill="#EFEFF2" width="46.901" height="6" />
        <rect x="473.308" y="54.053" fill="#EFEFF2" width="35.677" height="6" />
        <rect x="418.189" y="67.261" fill="#EFEFF2" width="46.902" height="6" />
        <rect x="473.509" y="67.259" fill="#EFEFF2" width="35.678" height="6" />
        <rect x="418.19" y="79.516" fill="#EFEFF2" width="46.901" height="6" />
        <rect
          x="473.508"
          y="79.514"
          fill="#EFEFF2"
          width="35.678"
          height="6.002"
        />
      </g>
      <path
        fill="#FFFFFF"
        d="M628.443,90.362c0,2.235-2.31,4.045-5.159,4.045h-91.5c-2.85,0-5.16-1.811-5.16-4.045V47.756
	c0-2.233,2.311-4.045,5.16-4.045h91.5c2.85,0,5.159,1.811,5.159,4.045V90.362z"
      />
      <path
        fill="#FFFFFF"
        d="M514.196,148.009c0,2.234-2.309,4.045-5.159,4.045h-91.5c-2.85,0-5.161-1.811-5.161-4.045v-42.605
	c0-2.233,2.311-4.045,5.161-4.045h91.5c2.85,0,5.159,1.811,5.159,4.045V148.009z"
      />
      <path
        fill="none"
        :stroke="color"
        stroke-miterlimit="10"
        d="M628.443,43.708"
      />
      <path
        fill="none"
        :stroke="color"
        stroke-miterlimit="10"
        d="M526.624,43.708"
      />
      <rect x="531.836" y="54.055" fill="#EFEFF2" width="46.901" height="6" />
      <rect x="587.153" y="54.053" fill="#EFEFF2" width="35.679" height="6" />
      <rect x="532.036" y="67.261" fill="#EFEFF2" width="46.901" height="6" />
      <rect x="587.354" y="67.259" fill="#EFEFF2" width="35.679" height="6" />
      <rect x="532.036" y="79.516" fill="#EFEFF2" width="46.9" height="6" />
      <rect
        x="587.353"
        y="79.514"
        fill="#EFEFF2"
        width="35.679"
        height="6.002"
      />
      <rect x="412.5" y="32.544" fill="#5B5B5B" width="49.153" height="4.52" />
      <g id="Layer_4">
        <path
          fill="#FFFFFF"
          d="M628.443,148.019c0,2.236-2.31,4.049-5.159,4.049h-91.5c-2.85,0-5.16-1.813-5.16-4.049v-42.627
		c0-2.234,2.311-4.046,5.16-4.046h91.5c2.85,0,5.159,1.812,5.159,4.046V148.019z"
        />
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="10"
          d="M628.443,101.344"
        />
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="10"
          d="M526.624,101.344"
        />
        <rect
          x="531.836"
          y="111.695"
          fill="#EFEFF2"
          width="46.901"
          height="6.003"
        />
        <rect
          x="587.153"
          y="111.694"
          fill="#EFEFF2"
          width="35.679"
          height="6.004"
        />
        <rect
          x="532.036"
          y="124.907"
          fill="#EFEFF2"
          width="46.901"
          height="6.004"
        />
        <rect
          x="587.354"
          y="124.907"
          fill="#EFEFF2"
          width="35.679"
          height="6.004"
        />
        <rect
          x="532.036"
          y="137.168"
          fill="#EFEFF2"
          width="46.9"
          height="6.003"
        />
        <rect
          x="587.353"
          y="137.167"
          fill="#EFEFF2"
          width="35.679"
          height="6.004"
        />
      </g>
      <rect
        x="417.99"
        y="111.697"
        fill="#EFEFF2"
        width="46.901"
        height="5.999"
      />
      <rect
        x="473.308"
        y="111.697"
        fill="#EFEFF2"
        width="35.678"
        height="5.999"
      />
      <rect x="418.19" y="124.902" fill="#EFEFF2" width="46.903" height="6" />
      <rect x="473.509" y="124.902" fill="#EFEFF2" width="35.678" height="6" />
      <rect
        x="418.19"
        y="137.157"
        fill="#EFEFF2"
        width="46.901"
        height="6.001"
      />
      <rect
        x="473.508"
        y="137.157"
        fill="#EFEFF2"
        width="35.678"
        height="6.001"
      />
      <g id="Layer_5"></g>
      <circle
        fill="#FFFFFF"
        stroke="#B2B2B2"
        stroke-width="0.5"
        stroke-miterlimit="10"
        cx="604.563"
        cy="23.353"
        r="4.52"
      />
      <rect
        x="611.134"
        y="22.011"
        fill="#5B5B5B"
        width="16.196"
        height="2.684"
      />
      <path
        :fill="color"
        d="M625.084,31.415c-0.232,0-0.458,0.025-0.677,0.072c-0.119-0.043-0.246-0.072-0.382-0.072h-25.883
	c-0.043,0-0.079,0.018-0.12,0.023c-0.074-0.005-0.145-0.023-0.22-0.023c-1.824,0-3.303,1.518-3.303,3.39
	c0,1.872,1.479,3.39,3.303,3.39c0.075,0,0.146-0.018,0.22-0.022c0.041,0.004,0.077,0.022,0.12,0.022h25.883
	c0.136,0,0.263-0.029,0.382-0.072c0.219,0.047,0.444,0.072,0.677,0.072c1.825,0,3.304-1.518,3.304-3.39
	C628.388,32.932,626.909,31.415,625.084,31.415z"
      />
      <rect
        x="394.476"
        y="19.455"
        transform="matrix(0.7164 0.6977 -0.6977 0.7164 129.2547 -271.2669)"
        :fill="color"
        width="7.632"
        height="7.795"
      />
      <rect x="395.762" y="31.598" width="5.551" height="0.527" />
      <rect x="395.762" y="32.598" width="5.551" height="0.527" />
      <rect x="395.762" y="33.598" width="5.551" height="0.527" />
      <g>
        <path
          :fill="color"
          d="M413.722,24.103h1.952v0.592h-2.68v-5.576h0.728V24.103z"
        />
        <path
          :fill="color"
          d="M417.562,24.386c-0.427-0.243-0.764-0.581-1.012-1.016c-0.248-0.435-0.372-0.924-0.372-1.468
		s0.124-1.033,0.372-1.468c0.248-0.435,0.585-0.773,1.012-1.016s0.898-0.364,1.416-0.364c0.522,0,0.997,0.122,1.424,0.364
		s0.763,0.58,1.008,1.012c0.245,0.432,0.368,0.923,0.368,1.472s-0.123,1.04-0.368,1.472c-0.246,0.432-0.582,0.769-1.008,1.012
		s-0.901,0.364-1.424,0.364C418.46,24.75,417.988,24.629,417.562,24.386z M420.029,23.846c0.312-0.181,0.558-0.44,0.736-0.776
		s0.268-0.725,0.268-1.168c0-0.448-0.089-0.839-0.268-1.172c-0.179-0.333-0.423-0.591-0.732-0.772
		c-0.31-0.182-0.662-0.272-1.056-0.272c-0.395,0-0.747,0.09-1.056,0.272c-0.309,0.181-0.553,0.438-0.732,0.772
		c-0.179,0.333-0.268,0.724-0.268,1.172c0,0.443,0.089,0.832,0.268,1.168s0.424,0.595,0.736,0.776
		c0.312,0.182,0.663,0.272,1.052,0.272C419.367,24.118,419.717,24.028,420.029,23.846z"
        />
        <path
          :fill="color"
          d="M426.961,20.734c-0.155-0.325-0.378-0.577-0.672-0.756s-0.635-0.268-1.024-0.268
		c-0.39,0-0.74,0.089-1.052,0.268s-0.557,0.435-0.736,0.768c-0.179,0.333-0.268,0.719-0.268,1.156s0.089,0.821,0.268,1.152
		c0.179,0.331,0.424,0.585,0.736,0.764s0.663,0.268,1.052,0.268c0.544,0,0.992-0.163,1.344-0.488
		c0.352-0.325,0.558-0.765,0.616-1.32h-2.224v-0.592h3v0.56c-0.042,0.459-0.187,0.879-0.432,1.26
		c-0.246,0.381-0.568,0.683-0.968,0.904c-0.4,0.222-0.845,0.332-1.336,0.332c-0.518,0-0.989-0.121-1.416-0.364
		s-0.764-0.58-1.012-1.012c-0.248-0.432-0.372-0.92-0.372-1.464s0.124-1.033,0.372-1.468c0.248-0.435,0.585-0.773,1.012-1.016
		s0.898-0.364,1.416-0.364c0.592,0,1.116,0.147,1.572,0.44c0.456,0.293,0.788,0.707,0.996,1.24H426.961z"
        />
        <path
          :fill="color"
          d="M430.073,24.386c-0.427-0.243-0.764-0.581-1.012-1.016c-0.248-0.435-0.372-0.924-0.372-1.468
		s0.124-1.033,0.372-1.468c0.248-0.435,0.585-0.773,1.012-1.016s0.898-0.364,1.416-0.364c0.522,0,0.997,0.122,1.424,0.364
		s0.763,0.58,1.008,1.012c0.245,0.432,0.368,0.923,0.368,1.472s-0.123,1.04-0.368,1.472c-0.246,0.432-0.582,0.769-1.008,1.012
		s-0.901,0.364-1.424,0.364C430.972,24.75,430.5,24.629,430.073,24.386z M432.541,23.846c0.312-0.181,0.558-0.44,0.736-0.776
		s0.268-0.725,0.268-1.168c0-0.448-0.089-0.839-0.268-1.172c-0.179-0.333-0.423-0.591-0.732-0.772
		c-0.31-0.182-0.662-0.272-1.056-0.272c-0.395,0-0.747,0.09-1.056,0.272c-0.309,0.181-0.553,0.438-0.732,0.772
		c-0.179,0.333-0.268,0.724-0.268,1.172c0,0.443,0.089,0.832,0.268,1.168s0.424,0.595,0.736,0.776
		c0.312,0.182,0.663,0.272,1.052,0.272C431.878,24.118,432.229,24.028,432.541,23.846z"
        />
      </g>
    </svg>
  </div>

</template>


<script>
export default {
  name: "theme-model",
  components: {},
  props: {
    color: {
      type: String,
      default: "",
      description: "theme color"
    },
  },
}
</script>